import _ from 'lodash'

function getFormattedErrorCode(error) {
  const errorCodeResp = _.get(error, ['response', 'data', 'error_code'])
  const errorCodeData = _.get(error, ['data', 'error_code'])
  const errorCode = errorCodeResp || errorCodeData
  return { formatted: errorCode ? `${errorCode} - ` : '', errorCode }
}

export default getFormattedErrorCode
